// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-wYWe","header":"styles_header__1sZ1U","text_wrapper":"styles_text_wrapper__NjLz2","content":"styles_content__Vbby4"};